/* eslint-disable */
import { BrowserRouter, Redirect, Switch, Route } from "react-router-dom";
import { BaseLayoutRoute } from "@app/layouts";
import { Banner } from "@app/pages/Banner";
import { News } from "@app/pages/News";
import { Faq } from "@app/pages/Faq";
import { Notification } from "@app/pages/Notification";
import { InjectAxiosInterceptors } from "./Axios";
import { HomePage } from "@app/pages";
import { AddBanner } from "@app/pages/Banner/AddBanner";
import { EditBanner } from "@app/pages/Banner/EditBanner";
import { EditNews } from "@app/pages/News/EditNews";
import { AddNews } from "@app/pages/News/AddNews";
import { AddFaq } from "@app/pages/Faq/AddFaq";
import { EditFaq } from "@app/pages/Faq/EditFaq";
import LoginPage from "@app/pages/Login";
import { EditNotification } from "@app/pages/Notification/EditNotification";

export const AppRouter = () => {
  return (
    <BrowserRouter>
      {/* <InjectAxiosInterceptors /> */}
      <Switch>
        {/* <AuthLayoutRoute exact path="/auth/sign-in" component={SignInPage} /> */}
        {/* <BaseLayoutRoute exact path="/sign-out" component={SignOutPage} /> */}

        {/* <BaseLayoutRoute exact path="/" component={ReportSummariesPage} /> */}
        {/* <BaseLayoutRoute exact path="/"> */}
        {/* <Redirect to="/participant-verifications" /> */}
        {/* </BaseLayoutRoute> */}
        {/* <BaseLayoutRoute exact path="/claims" component={ClaimPage} /> */}
        {/* <BaseLayoutRoute exact path="/participant-verifications" component={ParticipantVerificationsPage} /> */}
        {/* <BaseLayoutRoute exact path="/participant-verifications/pre-registration/:id" component={PreRegistrationPage} /> */}
        {/* <BaseLayoutRoute exact path="/claim-participants" component={ClaimParticipantListPage} /> */}
        {/* <BaseLayoutRoute exact path="/about" component={AboutPage} /> */}

        {/* user management */}
        {/* <BaseLayoutRoute exact path="/user-management/users" component={UsersPage} /> */}
        {/* <BaseLayoutRoute exact path="/user-management/permissions" component={PermissionsPage} /> */}
        {/* <BaseLayoutRoute exact path="/user-management/user-roles" component={UserRolesPage} /> */}
        <Route path="/login" component={LoginPage} />
        <BaseLayoutRoute exact path="/home" component={HomePage} />
        <BaseLayoutRoute exact path="/banner" component={Banner} />
        <BaseLayoutRoute exact path="/banner/add" component={AddBanner} />
        <BaseLayoutRoute exact path="/banner/edit" component={EditBanner} />

        <BaseLayoutRoute exact path="/news" component={News} />
        <BaseLayoutRoute exact path="/news/add" component={AddNews} />
        <BaseLayoutRoute exact path="/news/edit" component={EditNews} />

        <BaseLayoutRoute exact path="/faq" component={Faq} />
        <BaseLayoutRoute exact path="/faq/add" component={AddFaq} />
        <BaseLayoutRoute exact path="/faq/edit" component={EditFaq} />

        <BaseLayoutRoute exact path="/notification" component={Notification} />
        <BaseLayoutRoute
          exact
          path="/notification/edit"
          component={EditNotification}
        />

        <Redirect to="/login" />

        {/* <BaseLayoutRoute exact path="/diagnosis" component={DiagnosisPage} />
        <BaseLayoutRoute exact path="/kunjungan-rajal" component={KunjunganRajalPage} />
        <BaseLayoutRoute exact path="/kunjungan-ranap" component={KunjunganRanapPage} />
        <BaseLayoutRoute exact path="/biaya-rajal" component={BiayaRajalPage} />
        <BaseLayoutRoute exact path="/biaya-ranap" component={BiayaRanapPage} />
        <BaseLayoutRoute exact path="/sebaran-pasien" component={SebaranPasienPage} />
        <BaseLayoutRoute exact path="/kunjungan-unit" component={KunjunganUnitPage} />  */}
      </Switch>
    </BrowserRouter>
  );
};
